<template>
  <div class="SmugmugAlbumThumbnail"
    v-if="album"
    :class="classes">

    <component :is="route ? 'router-link' : 'div'"
      :style="SmugmugAlbumThumbnailLinkStyle"
      :to="route">

      <thumbnail class="SmugmugAlbumThumbnail-image"
        :image="resolvedImage"
        :tags="tags"
        :button="button"
        :ratio="ratio" />

    </component>

  </div>
</template>

<script>
export default {
  props: {
    albumKey: {
      type: String,
      required: false
    },
    image: {
      type: Object
    },
    route: {
      type: [Object, String],
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: Array
    }
  },

  data () {
    return {
      album: {
        count: 0
      }
    }
  },

  computed: {
    SmugmugAlbumThumbnailLinkStyle () {
      const style = {}

      if (this.route === '') {
        style['cursor'] = 'default'
      }

      return style
    },

    /**
     * Classes for the main element
     * @return {Object}
     */
    classes () {
      return {
        'SmugmugAlbumThumbnail--isLarge': this.large
      }
    },

    tags () {
      if (this.large) return

      return [
        {
          icon: 'photographs',
          label: this.album.count
        }
      ]
    },

    /**
     * Create button to use in Thumbnail
     * @return {Object}
     */
    button () {
      if (!this.album || !this.large) return false

      return {
        icon: 'photographs',
        label: 'View gallery',
        meta: this.album.count
      }
    },

    /**
     * Resolve the album image
     * @return {Object}
     */
    resolvedImage () {
      // const ratio = [3, 2]

      if (this.image) {
        this.image.zoom = this.image.zoom || true
        return this.image
      }

      if (!this.album) return false

      return {
        smugmug: this.album.images[0],
        // ratio: [3, 2],
        zoom: true
      }
    }
  },

  async created () {
    this.album = await this.$smugmug.getAlbum(this.albumKey)
  }
}
</script>



// WEBPACK FOOTER //
// SmugmugAlbumThumbnail.vue?53062d2d